/* Mimic add to cart on #add button clicks */
document.addEventListener('DOMContentLoaded', function () {
document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href="#add"], button[href="#add"]');
    if (!trigger) return;

    event.preventDefault();

    var mainAddToCartButton = document.querySelector(
    '[data-testid="standalone-add-to-cart"], .product-form-buttons button[name="add"], button.add-to-cart-button[name="add"]'
    );

    if (!mainAddToCartButton) return;

    mainAddToCartButton.click();
});
});

/* Calculate mobile menu top */
(function () {
  let ticking = false;
  let lastOffset = null;

  function getHeight(selector) {
    const el = document.querySelector(selector);
    return el ? Math.ceil(el.getBoundingClientRect().height) : 0;
  }

  function getAnnouncementOffset() {
    const announcement = document.querySelector('.announcement-bar');
    if (!announcement) return 0;

    const bottom = announcement.getBoundingClientRect().bottom;
    return bottom > 1 ? Math.ceil(bottom) : 0;
  }

  function updateOffset() {
    const headerHeight = getHeight('.header-section');
    const announcementOffset = getAnnouncementOffset();

    const offset = announcementOffset > 0
      ? headerHeight + announcementOffset
      : headerHeight - 1;

    if (offset === lastOffset) return;

    lastOffset = offset;
    document.documentElement.style.setProperty(
      '--dynamic-menu-drawer-top',
      Math.max(offset, 0) + 'px'
    );
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(function () {
      updateOffset();
      ticking = false;
    });
  }

  requestUpdate();

  window.addEventListener('load', requestUpdate);
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('scroll', requestUpdate, { passive: true });

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(requestUpdate);

    ['.announcement-bar', '.header-section'].forEach(function (selector) {
      const el = document.querySelector(selector);
      if (el) resizeObserver.observe(el);
    });
  }
})();

/* Add domain to terms pages */
document.addEventListener('DOMContentLoaded', function () {
  const shopDomain = window.location.origin;

  const containers = [
    document.querySelector('.page-width-content'),
    document.querySelector('.shopify-policy__container')
  ].filter(Boolean);

  if (!containers.length) return;

  const replaceContent = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.includes('{domain}') || node.nodeValue.includes('derilashop.co.uk')) {
        node.nodeValue = node.nodeValue
          .replaceAll('{domain}', shopDomain)
          .replaceAll('https://derilashop.co.uk', shopDomain);
      }
    }

    root.querySelectorAll('*').forEach(el => {
      [...el.attributes].forEach(attr => {
        if (attr.value.includes('{domain}') || attr.value.includes('derilashop.co.uk')) {
          el.setAttribute(
            attr.name,
            attr.value
              .replaceAll('{domain}', shopDomain)
              .replaceAll('https://derilashop.co.uk', shopDomain)
          );
        }
      });
    });
  };

  containers.forEach(container => replaceContent(container));

  containers.forEach(container => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            replaceContent(node);
          }
        });
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  });
});

/* Kaching bundles price + badge sync */
(() => {
  const SELECTED_BAR_SELECTOR = '.kaching-bundles__bar.kaching-bundles__bar--selected';

  const SRC_PRICE_SELECTOR = '.kaching-bundles__bar-price';
  const SRC_COMPARE_SELECTOR = '.kaching-bundles__bar-full-price';
  const SRC_LABEL_SELECTOR = '.kaching-bundles__bar-label';

  const MAIN_PRICE_CONTAINER_SELECTOR = 'product-price.h4 [ref="priceContainer"]';
  const STICKY_PRICE_CONTAINER_SELECTOR = '.sticky-add-to-cart__price [ref="priceContainer"]';

  let raf = 0;

  const cleanText = (el) => {
    return (el?.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const syncBadge = (priceContainer, labelText) => {
    const priceBadge = priceContainer?.querySelector('.price-badge');
    const priceBadgeText = priceContainer?.querySelector('.price-badge__text');

    if (!priceBadge || !priceBadgeText) return;

    if (labelText) {
      priceBadgeText.textContent = labelText;
      priceBadge.classList.remove('hidden', 'is-hidden');
      priceBadge.style.display = '';
    } else {
      priceBadgeText.textContent = '';
      priceBadge.classList.add('hidden');
      priceBadge.style.display = 'none';
    }
  };

  const syncMainPriceContainer = (priceContainer, priceText, compareText, labelText) => {
    if (!priceContainer || !priceText) return;

    const regularWrapper = priceContainer.querySelector('.price__regular');
    const saleWrapper = priceContainer.querySelector('.price__sale');

    const regularPriceEl = regularWrapper?.querySelector('.price');
    const salePriceEl = saleWrapper?.querySelector('.price-item--sale.price, .price');
    const comparePriceEl = saleWrapper?.querySelector('.compare-at-price');

    if (compareText && saleWrapper && salePriceEl && comparePriceEl) {
      salePriceEl.textContent = priceText;
      comparePriceEl.textContent = compareText;

      saleWrapper.classList.remove('price__hidden', 'hidden', 'is-hidden');
      saleWrapper.style.display = '';

      if (regularWrapper) {
        regularWrapper.classList.add('price__hidden');
        regularWrapper.style.display = 'none';
      }

      comparePriceEl.classList.remove('hidden', 'is-hidden');
      comparePriceEl.style.display = '';
    } else if (regularPriceEl) {
      regularPriceEl.textContent = priceText;

      if (regularWrapper) {
        regularWrapper.classList.remove('price__hidden', 'hidden', 'is-hidden');
        regularWrapper.style.display = '';
      }

      if (saleWrapper) {
        saleWrapper.classList.add('price__hidden');
        saleWrapper.style.display = 'none';
      }

      if (comparePriceEl) {
        comparePriceEl.textContent = '';
      }
    }

    syncBadge(priceContainer, labelText);
  };

  const syncStickyPriceContainer = (priceContainer, priceText, labelText) => {
    if (!priceContainer || !priceText) return;

    const regularWrapper = priceContainer.querySelector('.price__regular');
    const regularPriceEl = regularWrapper?.querySelector('.price');
    const saleWrapper = priceContainer.querySelector('.price__sale');

    if (regularPriceEl) {
      regularPriceEl.textContent = priceText;
    }

    if (regularWrapper) {
      regularWrapper.classList.remove('price__hidden', 'hidden', 'is-hidden');
      regularWrapper.style.display = '';
    }

    if (saleWrapper) {
      saleWrapper.classList.add('price__hidden');
      saleWrapper.style.display = 'none';
    }

    syncBadge(priceContainer, labelText);
  };

  const syncKachingPrice = () => {
    const selectedBar = document.querySelector(SELECTED_BAR_SELECTOR);
    if (!selectedBar) return;

    const priceText = cleanText(selectedBar.querySelector(SRC_PRICE_SELECTOR));
    const compareText = cleanText(selectedBar.querySelector(SRC_COMPARE_SELECTOR));
    const labelText = cleanText(selectedBar.querySelector(SRC_LABEL_SELECTOR));

    if (!priceText) return;

    document.querySelectorAll(MAIN_PRICE_CONTAINER_SELECTOR).forEach((priceContainer) => {
      syncMainPriceContainer(priceContainer, priceText, compareText, labelText);
    });

    document.querySelectorAll(STICKY_PRICE_CONTAINER_SELECTOR).forEach((priceContainer) => {
      syncStickyPriceContainer(priceContainer, priceText, labelText);
    });
  };

  const scheduleSync = () => {
    if (raf) cancelAnimationFrame(raf);

    raf = requestAnimationFrame(() => {
      syncKachingPrice();

      setTimeout(syncKachingPrice, 50);
      setTimeout(syncKachingPrice, 150);
      setTimeout(syncKachingPrice, 300);
    });
  };

  const init = () => {
    const root = document.querySelector('kaching-bundle, kaching-bundles-block, .kaching-bundles');

    if (!root) {
      requestAnimationFrame(init);
      return;
    }

    scheduleSync();

    document.addEventListener('click', (event) => {
      if (event.target.closest('.kaching-bundles')) {
        scheduleSync();
      }
    });

    document.addEventListener('change', (event) => {
      if (event.target.closest('.kaching-bundles')) {
        scheduleSync();
      }
    });

    const observer = new MutationObserver(scheduleSync);

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
      attributeFilter: ['class']
    });
  };

  init();
})();